import { useMutation } from "urql";

import { UpdateLegalDocumentDocument } from "../../../graphql/generated.ts";

export function useUpdateLegalDocument() {
  return useMutation(UpdateLegalDocumentDocument);
}
